var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 17 16",
    style: {
      enableBackground: "new 0 0 17 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.1,4.2c0.1-0.1,0.1-0.1,0.2-0.1c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.3,0.1c0.1,0,0.2,0.1,0.2,0.2l3.2,3.3 c0.1,0.1,0.2,0.3,0.2,0.5c0,0.2-0.1,0.3-0.2,0.5l-3.2,3.3c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0-0.2,0.1-0.3,0.1c-0.1,0-0.2,0-0.3,0 c-0.1,0-0.2-0.1-0.2-0.1c-0.1-0.1-0.1-0.1-0.2-0.2c0-0.1-0.1-0.2-0.1-0.3c0-0.1,0-0.2,0-0.3c0-0.1,0.1-0.2,0.1-0.2l2.1-2.2H7.8 c-0.2,0-0.4-0.1-0.5-0.2C7.2,8.4,7.1,8.2,7.1,8c0-0.2,0.1-0.4,0.2-0.5c0.1-0.1,0.3-0.2,0.5-0.2h6.4l-2.1-2.2C12,5,11.9,4.8,11.9,4.7 C11.9,4.5,12,4.3,12.1,4.2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0.5,0.7c0-0.2,0.1-0.4,0.2-0.5C0.8,0.1,1,0,1.2,0h8.6c0.2,0,0.4,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.5v2.7 c0,0.2-0.1,0.4-0.2,0.5C10.2,4,10,4.1,9.8,4.1C9.6,4.1,9.5,4,9.3,3.9C9.2,3.8,9.1,3.6,9.1,3.4V1.4H1.9v13.3h7.3v-2.1 c0-0.2,0.1-0.4,0.2-0.5c0.1-0.1,0.3-0.2,0.5-0.2c0.2,0,0.4,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.5v2.7c0,0.2-0.1,0.4-0.2,0.5 C10.2,15.9,10,16,9.8,16H1.2c-0.2,0-0.4-0.1-0.5-0.2s-0.2-0.3-0.2-0.5V0.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.63470498d0577dad312acfe4d53a058a.svg";
export { ForwardRef as ReactComponent };